export const PATH_ROOT = '/';
